// extracted by mini-css-extract-plugin
export var header = "component-module--header--12svZ";
export var logo = "component-module--logo--xB1C5";